import { Component, TemplateRef } from '@angular/core';
import { GenericResponse } from 'src/app/api-interfaces';
import { NotificationService } from 'src/app/shared/notification.service';
import { RequestService } from '../requests/request.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { IdentityService } from '../identity.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ValidatorService } from 'src/app/shared/validator.service';
import { ErrorService } from 'src/app/shared/errors.service';
import { SearchService } from 'src/app/shared/search/search.service';
import { RequestsComponent } from '../requests/requests.component';
import { FuncsService } from 'src/app/shared/funcs.service';
import { Filter, SearchData } from 'src/app/shared/search/search.model';
import { Request } from '../requests/request.model';


@Component({
  selector: 'app-draft',
  templateUrl: './draft.component.html',
  styleUrls: ['./draft.component.sass']
})
export class DraftComponent extends RequestsComponent {
  title: string = "Bozze";
  isRequest: boolean = false;
  drafts = this.requestService.drafts$;
  validateForm: UntypedFormGroup;
  tplModal?: NzModalRef;
  allowedOperations: Array<string> = [];
  isSpinning$ = this.requestService.isSpinning$;

  filterStatus: Filter[] = [
    {text: "Issued", value: "ISSUED"},
    {text: "Created", value: "CREATED"},
    {text: "Canceled", value: "CANCELED"},
    {text: "Completed", value: "COMPLETED"},
  ]

  constructor(
    public fb: UntypedFormBuilder,
    public funcs: FuncsService,
    public searchService: SearchService,
    public requestService: RequestService,
    public modalService: NzModalService,
    public identityService: IdentityService,
    public validatorService: ValidatorService,
    public errorService: ErrorService,
    public notificationService: NotificationService,
    public authService: AuthService,
  )
  {
    super(funcs, searchService, requestService, identityService, notificationService, authService);
    this.allowedOperations = this.requestService.obtainAllowedOperations();

    this.validateForm = this.fb.group({
      draftCreate: this.fb.group({
        fiscalCode: [ null, [Validators.required,  Validators.maxLength(16), Validators.minLength(16)]],
        email: [null, [ Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")], [validatorService.emailValidator()]],
      }),
    });
    this.searchService.searchData = SearchData.Drafts;
  }

  ngOnInit(): void {
    this.searchService.resetSearchFields();
  }

  getFormGroup(name: string = "draftCreate"): UntypedFormGroup {
    return this.validateForm.get(name) as UntypedFormGroup;
  }

  onCreate(content: TemplateRef<{}>, modalFooter: TemplateRef<{}>) {
    this.validateForm.reset();
    this.tplModal = this.modalService.create({
      nzTitle: $localize`:Draft.CreateDraft.TitleModal|title of request modal@@Draft.CreateDraft:Crea bozza`,
      nzContent: content,
      nzFooter: modalFooter,
    });
  }

  canCreateDraft(): boolean {
    const isStatusAllowed: boolean = this.requestService.hasStatusAllowed();
    return (this.allowedOperations.includes('showCreateDraft') && isStatusAllowed)
  }

  canBeCancelled(draft: Request): boolean {
    const isStatusAllowed: boolean = this.requestService.hasStatusAllowed();
    return (this.allowedOperations.includes('showCancelDraft') && !["CANCELED", "COMPLETED"].includes(draft.status) && isStatusAllowed);
  }

  canBeCompiled(draft: Request): boolean {
    const isStatusAllowed: boolean = this.requestService.hasStatusAllowed();
    return (this.allowedOperations.includes('showCompileDraft') && draft.status == "CREATED" && isStatusAllowed);
  }

  canDoAction(draft: Request): boolean {
    return (this.canBeCancelled(draft) || this.canBeCompiled(draft));
  }


  createDraft() {
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }

    let fiscalCode: string = this.validateForm.get("draftCreate").value["fiscalCode"];
    let email: string = this.validateForm.get("draftCreate").value["email"];

    if (!fiscalCode || !email ) {
      return;
    }

    this.requestService.isSpinning.next(true);
    this.identityService.createDraft(fiscalCode, email).subscribe(
      (response: GenericResponse) => {
        if (response["esito"] == "OK") {
          this.validateForm.reset()
          this.tplModal.close();
          this.searchService.search();
        }
      },
      (err: any) => {
        this.requestService.isSpinning.next(false);
      },
      () => { this.requestService.isSpinning.next(false); }
    );
  }

  cancelDraft(requestId: number) {
    if ( !requestId ) {
      return
    }

    this.requestService.isSpinning.next(true);
    this.identityService.cancelDraft(requestId).subscribe(
      (response: GenericResponse) => {
        if (response["esito"] == "OK") {
          this.requestService.isSpinning.next(false);
          this.validateForm.reset()
          this.searchService.search();
        }
      },
      (err: any) => {
        this.requestService.isSpinning.next(false);
      },
      () => { this.requestService.isSpinning.next(false); }
    );
  }

  compileDraft(draft: Request) {
    this.requestService.draftToCompile.next(draft);
    this.identityService.currentViewChanged.next('compileDraft');
  }

  getErrorCode(fieldName: string, defaultMessage: string): string {
    const errors = this.validateForm.controls["draftCreate"].get(fieldName).errors;
    if(!errors)
    {
      return defaultMessage;
    }
    let errorCode = errors.errorCode;
    if (!errorCode) {
      return defaultMessage;
    }
    const errorObject = this.errorService.getErrorBycode(errorCode)
    return errorObject ? errorObject.message : defaultMessage
  }

}
